// removed by extract-text-webpack-plugin
module.exports = {"modal-title":"_2Y_MNoYQiyuOj6WXj7xXuU","modal-body":"gPFYBiAbyQ7TzrjVYLenD","buttonWrapper":"rHztE93U5YQF7r8U8sBZ_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModalForm/styles.css
// module id = 3158
// module chunks = 0